import { render, staticRenderFns } from "./PayWithPo.vue?vue&type=template&id=0f3d706a&scoped=true"
import script from "./PayWithPo.vue?vue&type=script&lang=js"
export * from "./PayWithPo.vue?vue&type=script&lang=js"
import style0 from "./PayWithPo.vue?vue&type=style&index=0&id=0f3d706a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d706a",
  null
  
)

export default component.exports